import { render } from "./TextBlock.vue?vue&type=template&id=1e4e78d3&ts=true"
import script from "./TextBlock.vue?vue&type=script&lang=ts"
export * from "./TextBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__